import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import UserContext from '../../../../navigation/context/userContext';
import { Chip, Icon, IconButton, Typography, useTheme } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faEye, faListAlt, faPlay, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteDialog from '../../../../components/DeleteDialog';


//export default class TablaProductos extends Component
export default function AttributesDataTable({attributes, onDeleteAttribute, isLoading})
{
    const {userData,setUserData} = useContext(UserContext);
    const theme = useTheme();

    const [attributeToRemove,setAttributeToRemove] = useState(null);
    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    const handleOpenDialog = (attribute) => {
        setAttributeToRemove(attribute);
        setOpenDeleteDialog(true);
    }

    const columns = [
        {
            name : 'id',
            label : 'ID',
        },
        {
            name : 'name',
            label : 'Nombre',
        },
        {
            name : 'created_at',
            label : 'Valores',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    if(attributes[dataIndex].attribute_values.length > 0)
                    {
                        return attributes[dataIndex].attribute_values.map((value)=>
                            <Chip key={value.id} label={value.value} sx={{marginRight:2}} />
                        ) 
                    }
                    else
                    {
                        return <Typography>No hay valores</Typography>
                    }
                        
                },
                    //let id = subCategorias[dataIndex].idSubCategoria;
                filter:false
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = attributes[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            {/*<Link 
                                to={'/products/attributes/update/'+attributes[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('categoria',JSON.stringify(attributes[dataIndex])) }
                                replace
                            >
                                <IconButton>
                                    <FontAwesomeIcon icon={faEdit}/>
                                </IconButton>
                            </Link>*/}

                            <Link 
                                to={'/products/attributes/values/'+attributes[dataIndex].id} 
                                //onClick={ ()=> localStorage.setItem('categoria',JSON.stringify(attributes[dataIndex])) }
                                replace
                            >
                                <IconButton color='link'>
                                    <FontAwesomeIcon icon={faEye}/>
                                </IconButton>
                            </Link>

                            <IconButton color='error' onClick={()=>handleOpenDialog(attributes[dataIndex])}>
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </IconButton>
                        </div>
                    );
                },

                print : false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
                title={"Listado de Atributos"}
                data={attributes}
                columns={columns}
                options={options}
            />

            <DeleteDialog
                open={openDeleteDialog}
                title={'Eliminar Atributo'}
                message={'¿Estás seguro que deseas eliminar este atributo?'}
                onClose={ () => setOpenDeleteDialog(false) }
                onConfirm={ async () => {
                    await onDeleteAttribute(attributeToRemove.id);
                    setOpenDeleteDialog(false);
                } }
                isLoading={isLoading}
            />
        </>
    )
}